"use client";
import React, { useMemo, useState } from "react";
import Script from "next/script";

export const HubspotContext = React.createContext();

export const HubspotProvider = ({ children }) => {
  const [hubspotObj, setHubspotObj] = useState();
  const [loadHubspotScript, setLoadHubspotScript] = useState(false);

  const initHubspot = () => {
    if (hubspotObj) return;
    setLoadHubspotScript(true);
  };

  const value = useMemo(() => ({ hubspotObj, initHubspot }), [hubspotObj])

  return (
    <>
      {loadHubspotScript && (
        <Script
          strategy="lazyOnload"
          src="https://js.hsforms.net/forms/v2.js"
          key="hbspt"
          onLoad={() => setHubspotObj(window.hbspt)}
        />
      )}
      <HubspotContext.Provider value={value}>
        {children}
      </HubspotContext.Provider>
    </>
  );
};
